document.addEventListener('click', function(e) {
    // Find the closest element with the 'email-conf' class (in case they click the <span> inside it)
    var emailConfLink = e.target.closest('.email-conf');
    
    if (emailConfLink) {
        // 1. Find the close button inside the active modal and trigger it
        var closeButton = document.querySelector('.entry-modal_wrapper .modal_close_btn');
        if (closeButton) {
            closeButton.click();
        }
        
        // 2. Get the target ID from the href attribute (e.g., "#PageContainer")
        var targetId = emailConfLink.getAttribute('href');
        
        if (targetId && targetId.startsWith('#')) {
            var targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                // 3. Smoothly scroll to the element
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }
});